import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer, WishlistDrawer } from "./Drawers";
import { SearchOverlay } from "./SearchOverlay";
import { QuickView } from "./QuickView";
import { CheckoutModal } from "./CheckoutModal";
import { BackToTop } from "./BackToTop";

export function Layout({ children }) {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>{children}</main>
      <Footer />
      <CartDrawer />
      <WishlistDrawer />
      <SearchOverlay />
      <QuickView />
      <CheckoutModal />
      <BackToTop />
    </div>
  );
}
